import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Styles } from "./styles/homeContact.js";
import axios from "axios";
import { Constant } from "../helper/Constants.js";

function HelpArea() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    location: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [statusMsg, setStatusMsg] = useState("");
  const [statusType, setStatusType] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const isEmail = (email) =>
    /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email);

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Name can't be blank";
    if (!formData.email.trim()) newErrors.email = "Email can't be blank";
    else if (!isEmail(formData.email.trim()))
      newErrors.email = "Not a valid email";

    if (!formData.phone.trim()) newErrors.phone = "Phone number can't be blank";

    if (!formData.location.trim())
      newErrors.location = "Location can't be blank";

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setStatusMsg("");
    setStatusType("");

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setSubmitting(true);

    try {
      await axios.post(Constant.postUrls.submitFranchiseEnquiry, formData);

      setStatusType("success");
      setStatusMsg("Thank you! Your franchise enquiry has been submitted.");
      setTimeout(() => {
        setStatusMsg("")
      }, 3000);

      setFormData({
        name: "",
        email: "",
        phone: "",
        location: "",
        message: "",
      });
    } catch (err) {
      setStatusType("error");
      setStatusMsg(
        err?.response?.data?.message ||
          "Something went wrong. Please try again later."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Styles>
      <section className="home-contact-area" id="franchiseEnquiry">
        <Col md="12">
          <div className="sec-title text-center">
            <h4>
              If You have Any Question Please Don't Hesitate To Contact Us"
            </h4>
          </div>
        </Col>
        <Container>
          <Row className="align-items-center">
            {/* LEFT IMAGE */}
            <Col md="6" className="mb-4 mb-md-0">
              <div className="contact-left-image">
                <img
                  src={
                    process.env.PUBLIC_URL + "/assets/images/franchiseEnq.png"
                  }
                  className="img-fluid"
                  alt="Franchise Enquiry"
                />
              </div>
            </Col>

            {/* RIGHT SIDE FORM */}
            <Col md="6">
              <div className="sec-title">
                {/* <h4>Franchise Enquiry</h4> */}
                <p className="text-white">
                  Join hands with us and bring quality education to your city.
                  Fill in your details and we will contact you soon.
                </p>
              </div>

              <form className="form" onSubmit={handleSubmit}>
                <Row>
                  {/* NAME */}
                  <Col md="6" className="mb-4">
                    <p
                      className={`form-control ${
                        errors.name ? "error" : formData.name ? "success" : ""
                      }`}
                    >
                      <input
                        type="text"
                        name="name"
                        placeholder="Your Name"
                        value={formData.name}
                        onChange={handleChange}
                      />
                      <span className="input-msg1">{errors.name}</span>
                    </p>
                  </Col>

                  {/* EMAIL */}
                  <Col md="6" className="mb-4">
                    <p
                      className={`form-control ${
                        errors.email ? "error" : formData.email ? "success" : ""
                      }`}
                    >
                      <input
                        type="email"
                        name="email"
                        placeholder="Your Email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                      <span className="input-msg1">{errors.email}</span>
                    </p>
                  </Col>

                  {/* PHONE */}
                  <Col md="6" className="mb-4">
                    <p
                      className={`form-control ${
                        errors.phone ? "error" : formData.phone ? "success" : ""
                      }`}
                    >
                      <input
                        type="text"
                        name="phone"
                        placeholder="Phone Number"
                        value={formData.phone}
                        onChange={handleChange}
                      />
                      <span className="input-msg1">{errors.phone}</span>
                    </p>
                  </Col>

                  {/* LOCATION */}
                  <Col md="6" className="mb-4">
                    <p
                      className={`form-control ${
                        errors.location
                          ? "error"
                          : formData.location
                          ? "success"
                          : ""
                      }`}
                    >
                      <input
                        type="text"
                        name="location"
                        placeholder="Your City / Location"
                        value={formData.location}
                        onChange={handleChange}
                      />
                      <span className="input-msg1">{errors.location}</span>
                    </p>
                  </Col>

                  {/* MESSAGE */}
                  <Col md="12" className="mb-4">
                    <div className="form-control input-like">
                      <textarea
                        name="message"
                        rows="4"
                        placeholder="Additional Details (optional)"
                        value={formData.message}
                        onChange={handleChange}
                        className="textarea-input"
                      ></textarea>
                    </div>
                  </Col>

                  {/* BUTTON */}
                  <Col md="12" className="text-center">
                    <button type="submit" disabled={submitting}>
                      {submitting ? "Sending..." : "Send Request"}
                    </button>

                    {statusMsg && (
                      <p
                        className={`text-white mt-3 status-msg ${
                          statusType === "success"
                            ? "status-success"
                            : "status-error"
                        }`}
                      >
                        {statusMsg}
                      </p>
                    )}
                  </Col>
                </Row>
              </form>
            </Col>
          </Row>
        </Container>
      </section>
    </Styles>
  );
}

export default HelpArea;
